<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="grid"
        title="자재 목록"
        tableId="grid"
        :columns="grid.columns"
        :data="grid.data"
        selection="multiple"
        rowKey="equipmentMaterialCd"
        :isFullScreen="false"
        :columnSetting="false"
        :filtering="false"
      >
        <!-- 버튼 영역 -->
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable" label="추가" icon="add" @btnClicked="addrow" />
              <c-btn v-if="editable" label="저장" icon="save" @btnClicked="saveMat" />
              <c-btn v-if="editable" label="삭제" icon="remove" @btnClicked="deleteMat" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'equipment-bom',
  props: {
    param: {
      type: Object,
      default: () => ({
        equipmentCd: '',
        plantName: '',
        plantCd: '',
        processCds: [],
        equipmentTypeName: '',
        equipmentName: '',
      }),
    },
  },
  data() {
    return {
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '50%',
        param: {},
        closeCallback: null,
      },
      grid: {
        columns: [
          {
            name: 'processCd',
            field: 'processCd',
            valueName: 'codeName',
            label: '공정',
            align: 'center',
            sortable: false,
            type: 'select',
            comboItems: this.param.processCds,
          },
          {
            name: 'materialName',
            field: 'materialName',
            label: '자재명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'chemMaterialFlag',
            field: 'chemMaterialFlag',
            label: '화학자재 여부',
            align: 'center',
            sortable: false,
            type: 'check',
            true: 'Y',
            false: 'N'
          },
          {
            name: 'chemDailyVolume',
            field: 'chemDailyVolume',
            label: '화학자재 일 취급량',
            align: 'center',
            type: 'text',
            sortable: false,
          },
          {
            name: 'chemDailyHour',
            field: 'chemDailyHour',
            label: '화확자재 일 취급시간',
            align: 'center',
            type: 'text',
            sortable: false,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      saveUrl: '',
      deleteUrl: '',
      processItems: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
    param() {
      this.getList()
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.equipment.material.list.url;
      this.saveUrl = transactionConfig.mdm.equipment.material.save.url;
      this.deleteUrl = transactionConfig.mdm.equipment.material.delete.url;
      this.getList();
    },
    getList() {
      if (this.param.equipmentCd) {
        this.$http.url = this.listUrl;
        this.$http.param = {equipmentCd: this.param.equipmentCd};
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.grid.data = _result.data;
        },);
      }
    },
    saveMat() {
      let checkItem = ['processCd', 'materialCd']
      let isConti = true;
      this.$_.forEach(this.grid.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });
      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [공정, 자재]',
          type: 'warning', // success / info / warning / error
        });
      } else {
        let isDupl = false;
        this.$_.forEach(this.grid.data, item => {
          let _cnt = 0
          this.$_.forEach(this.grid.data, _item => {
            if (item.materialCd == _item.materialCd && item.processCd == _item.processCd) {
              _cnt++;
            }
          });
          if (_cnt > 1) {
            isDupl = true;
            return false;
          }
        });
        if (isDupl) {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: '중복된 공정/자재가 있습니다.', /* 중복된 공정/자재가 있습니다. */
            type: 'warning', // success / info / warning / error
          });
          return false;
        }
        let saveData = this.grid.data.filter( x => {
          return x.editFlag == 'C' || x.editFlag == 'U'
        });
        this.$_.forEach(saveData, item => {
          item.regUserId = this.$store.getters.user.userId;
          item.chgUserId = this.$store.getters.user.userId;
        });
        if(saveData.length > 0) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            type: 'info',
            // 확인 callback 함수
            confirmCallback: () => {
              this.$http.url = this.saveUrl;
              this.$http.type = 'POST';
              this.$http.param = saveData;
              this.$http.request(() => {
                this.getList();
                window.getApp.$emit('ALERT', {
                  title: '안내 ', /* 안내 */
                  message: '저장되었습니다.', /* 저장되었습니다. */
                  type: 'success', // success / info / warning / error
                });
              });
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('ALERT', {
            title: '안내 ', /* 안내 */
            message: '변경된 데이터가 없습니다.', /* 변경된 데이터가 없습니다. */
            type: 'info', // success / info / warning / error
          });
        }
      }
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          this.grid.data.push({
            editFlag: 'C',
            equipmentMaterialCd: '',
            equipmentCd: this.param.equipmentCd,
            processCd: '',
            materialCd: item.materialCd,
            materialName: item.materialName,
            chemMaterialFlag: item.chemMaterialFlag,
            chemDailyVolume: '',
            chemDailyHour: '',
          })
        });
      }
    },
    addrow() {
      this.popupOptions.title = '자재 목록';
      this.popupOptions.param = {
        type: 'multiple',
      };
      this.popupOptions.target = () => import(`${'@/pages/common/material/materialPop.vue'}`);
      this.popupOptions.width = '100%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    deleteMat() {
      let selectData = this.$refs['grid'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.$format(this.deleteUrl);
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            };
            this.$http.request(() => {
              this.getList();
              window.getApp.$emit('ALERT', {
                title: '안내 ', /* 안내 */
                message: '삭제되었습니다.', /* 삭제되었습니다. */
                type: 'success', // success / info / warning / error
              });
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>